import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('userInfo');
    if (stored) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const getConfig = React.useCallback(() => ({
    headers: { Authorization: `Bearer ${user?.token}` },
  }), [user?.token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API_URL}/users/login`, { email, password });
    setUser(data);
    localStorage.setItem('userInfo', JSON.stringify(data));
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await axios.post(`${API_URL}/users/register`, { name, email, password });
    setUser(data);
    localStorage.setItem('userInfo', JSON.stringify(data));
    return data;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('userInfo');
  };

  const updateProfile = async (userData) => {
    const { data } = await axios.put(`${API_URL}/users/profile`, userData, getConfig());
    const updated = { ...user, ...data, token: user.token };
    setUser(updated);
    localStorage.setItem('userInfo', JSON.stringify(updated));
    return data;
  };

  const addAddress = async (addressData) => {
    const { data } = await axios.post(`${API_URL}/users/address`, addressData, getConfig());
    const updated = { ...user, addresses: data };
    setUser(updated);
    localStorage.setItem('userInfo', JSON.stringify(updated));
    return data;
  };

  const toggleFavorite = async (productId) => {
    const { data } = await axios.post(`${API_URL}/users/favorites/${productId}`, {}, getConfig());
    const updated = { ...user, favorites: data.map((p) => p._id || p) };
    setUser(updated);
    localStorage.setItem('userInfo', JSON.stringify(updated));
    return data;
  };

  const isFavorite = (productId) => {
    return user?.favorites?.some((f) => (f._id || f) === productId) || false;
  };

  return (
    <AuthContext.Provider
      value={{
        user, loading, login, register, logout, 
        updateProfile, addAddress, getConfig,
        toggleFavorite, isFavorite
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
